import { enhancedTmsApiService } from './enhancements/enhancedTmsApiService'

export const {
  useGetProductdataMarketByMarketIdLanguagesQuery: useMarketLanguagesQuery,
  useGetProductdataGetvehicletypeidsQuery: useVehicleTypeIdsQuery,
  useGetProductdataGetviewheadersByMarketIdQuery: useViewsByMarketIdQuery,
  useGetUserdataGetmarketsQuery: useGetMarketsQuery,
  useGetProductdataGetconfigurationtypeidsQuery: useGetConfigurationTypeIds,
  useGetProductdataMarketByMarketIdPartPeriodFromDesiredDealerDateQuery: usePartPeriodFromDesiredDealerDateQuery,

  // configuration mutations
  usePostConfigurationByUuidSelectVariantsMutation: useSelectVariantsMutation,
  usePostConfigurationByUuidStepAndStepMutation: useConfigurationStepMutation,
  usePostConfigurationMutation: useStartConfigurationMutation,
  usePostConfigurationByUuidUndocommitMutation: useUndoVariantSelectMutation,
  usePutConfigurationByUuidChangeGroupOfInterestMutation: useCompatibilityCheckMutation,

  // market
  useGetAdmintoolMarketsQuery,
  usePutAdmintoolMarketsByMarketIdMutation: useUpdateMarketMutation,
  usePostAdmintoolMarketsMutation: useCreateMarketMutation,
  useDeleteAdmintoolMarketsByMarketIdMutation: useDeleteMarketMutation,

  // reference trucks
  useGetAdmintoolMarketsByMarketIdReferenceTrucksQuery,
  useGetAdmintoolMarketsByMarketIdReferenceTrucksQuery: useGetReferenceTrucksQuery,
  usePostAdmintoolMarketsByMarketIdReferenceTrucksMutation: useCreateReferenceTruckMutation,
  usePutAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdMutation: useUpdateReferenceTruckMutation,
  useDeleteAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdMutation: useDeleteReferenceTruckMutation,

  // factory code attributes
  usePostAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdMutation: useCreateFactoryCodeAttributesMutation,
  usePutAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdMutation: useUpdateFactoryCodeAttributesMutation,
  useDeleteAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdMutation: useDeleteFactoryCodeAttributesMutation,

  // national code groups
  usePostAdmintoolMarketsByMarketIdGroupsMutation: useCreateGroupMutation,
  usePutAdmintoolMarketsByMarketIdGroupsAndGroupIdMutation: useUpdateGroupMutation,
  useDeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdMutation: useDeleteGroupMutation,

  // national code families
  usePostAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesMutation: useCreateFamilyMutation,
  usePutAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdMutation: useUpdateFamilyMutation,
  useDeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdMutation: useDeleteFamilyMutation,

  // national code variants
  usePostAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsMutation: useCreateVariantMutation,
  usePutAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdMutation: useUpdateVariantMutation,
  useDeleteAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdMutation: useDeleteVariantMutation,
} = {
  ...enhancedTmsApiService,
}
